/** Branch row from `GET branches` — `{ id, name, code, company_id }`. */
export interface BranchRecord {
  id: number;
  name: string;
  code?: string;
  company_id: number;
}

export function findBranchByName(
  list: BranchRecord[] | undefined,
  selectedName: string | number
): BranchRecord | undefined {
  if (!list?.length || selectedName === -1) return undefined;
  return list.find((b) => b.name === selectedName);
}
